module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "align": "left"
    }
  }, [_c('edit-pane', {
    ref: "sra",
    attrs: {
      "prefix": "Payment: ",
      "title": _vm.form.summary,
      "editable": _vm.disabled,
      "adding": true,
      "is-edit": false
    },
    on: {
      "cancel": _vm.onCancel,
      "add": _vm.onAdd
    }
  }), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.form,
      "inline": "",
      "label-position": "left"
    }
  }, [(_vm.form.started || !_vm.disabled) ? _c('date-input', {
    attrs: {
      "label": "Started",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.started),
      callback: function($$v) {
        _vm.$set(_vm.form, "started", $$v)
      },
      expression: "form.started"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.expiry || !_vm.disabled) ? _c('date-input', {
    attrs: {
      "label": "Expiry",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.expiry),
      callback: function($$v) {
        _vm.$set(_vm.form, "expiry", $$v)
      },
      expression: "form.expiry"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.amount || !_vm.disabled) ? _c('currency-input', {
    attrs: {
      "label": "Amount",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.amount),
      callback: function($$v) {
        _vm.$set(_vm.form, "amount", $$v)
      },
      expression: "form.amount"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTax() && this.taxes) ? _c('el-form-item', {
    attrs: {
      "label": _vm.taxLabel
    }
  }, [_c('b', [_vm._v(_vm._s(this.formatNumber(this.taxes, 2)))])]) : _vm._e(), _vm._v(" "), (_vm.showTax() && this.totals) ? _c('el-form-item', {
    attrs: {
      "label": "Total"
    }
  }, [_c('b', [_vm._v(_vm._s(this.formatNumber(this.totals, 2)))])]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-562222e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/finance/revenue/SiteRevenueAdd.vue
// module id = 1499
// module chunks = 0